import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import { CodeBlock, BlockType, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit_52 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_52';
        this.name = 'Tibbit 52';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt52/tbt52.tbh',
            'libraries/tibbits/tbt52/tbt52.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                readonly: true,
                default: 'NO',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 52 on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    if tbt52_init(YES,${this.getSettingValue('NAME')}_CLK,${this.getSettingValue('NAME')}_DATA,${this.getSettingValue('NAME')}_MCLR,${this.getSettingValue('NAME')}_INT,${this.getSettingValue('NAME')}_CHANNEL)=NG then
        sys.debugprint("SSI channel could not be allocated for the ADC module (#52),  using bit banging instead.\\r\\n")
    end if

    ${this.getSettingValue('NAME')}_ADC_CHANNEL=ADC_4'<<====================================== SELECT DESIRED ADC CHANNEL HERE
    tbt52_channel_select(${this.getSettingValue('NAME')}_ADC_CHANNEL)

    '-----------------------------------------------------------------
        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${this.getSettingValue('NAME')}_ADC_CHANNEL as tbt52_nums
declare ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${this.getSettingValue('NAME')}_ADC_CHANNEL as tbt52_nums
dim ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_CLK=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_DATA=${socket?.pins[1]}
const ${this.getSettingValue('NAME')}_MCLR=${socket?.pins[2]}
const ${this.getSettingValue('NAME')}_INT=${socket?.pins[3]}`,
        });


        return blocks;
    }
}
